import { render, staticRenderFns } from "./GroupMemberAdd.vue?vue&type=template&id=37b5a2fc"
import script from "./GroupMemberAdd.vue?vue&type=script&lang=js"
export * from "./GroupMemberAdd.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberAdd.vue?vue&type=style&index=0&id=37b5a2fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports